import PropTypes from 'prop-types';
import React from 'react';
import Badge from '../badge';
import { getUserRole } from '../../services/user-role';

const UserBadge = ({ user, hideRoles = [] }) => {
  const role = getUserRole(user);
  return role && hideRoles.indexOf(role) === -1 ? <Badge role={role}/> : null;
};

UserBadge.propTypes = {
  user: PropTypes.object.isRequired,
  hideRoles: PropTypes.arrayOf(PropTypes.string),
};

export default UserBadge;



// WEBPACK FOOTER //
// ./app/components/user-badge/user-badge.js